module.exports = __webpack_public_path__ + "img/INT Overstocklogo.fba2a0e3.svg";